import {Component} from '@angular/core';

@Component({
    selector: 'app-peer-to-peer',
    templateUrl: './peer-to-peer-lending.html',
    styleUrls: ['./article.component.css']
})

export class PeerToPeerComponent {
}